import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
} from '@mui/material';
import { ArticleTwoTone } from '@mui/icons-material';
import { apiurl } from './constants';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const IGotItDialog = ({ successMessage, open, setOpen }) => {
  
  const handleIGotIt = () => {
    localStorage.iGotItOnSignUpThankYou = true;

    handleClose();
  };

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} TransitionComponent={Transition} onClose={handleClose}>
      <DialogTitle>Thank You</DialogTitle>
      <DialogContent dividers>
        {successMessage?.length > 0 && (
          <Alert severity="success" sx={{ marginBottom: '1em' }}>
            {successMessage}
          </Alert>
        )}
        <Button
          variant="contained"
          target="_blank"
          startIcon={<ArticleTwoTone />}
          href={apiurl.volunteerResources}
        >
          Resources
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleIGotIt} variant="outlined">
          I Got It
        </Button>
        <Button onClick={handleClose} variant="contained">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export { IGotItDialog };
